var map = {
	"./01 NEW PEMBACAAN DOKTRIN PERTAMA KALI_22 MARET 2023_1.mp4": 16836,
	"./02 BTS VIDEO DOKTRIN..mp4": 49015,
	"./03 NEW Mars BNN RI Rekor MURI_1.mp4": 77841,
	"./04 Video Deputi Bidang Cegah.mp4": 20681,
	"./dummy.txt": 15514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69860;